var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_block"},[_vm._t("title",function(){return [(_vm.title)?_c('content-title',[_vm._v(_vm._s(_vm.title))]):_vm._e()]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }